module.exports = __webpack_public_path__ + "static/assets/575f42b3454a2f5787c2e97291e30982.svg";